import {
  format,
  formatSpecifier,
  FormatSpecifier,
  precisionFixed
} from 'd3-format'

function formatAlertValue(value: number, formatValue: any): string {
  if (!value || value <= 0) return '0'
  if (value <= 999) return value.toString()
  return format(formatValue)(value).toUpperCase()
}

const alertFormat: FormatSpecifier = formatSpecifier('s')
alertFormat.precision = precisionFixed(0.01)
alertFormat.trim = true

export { formatAlertValue, alertFormat }
